import { LoadingButton } from '@mui/lab';
import {
    Box,
    Button,
    Checkbox,
    Dialog,
    IconButton,
    Stack,
    Typography,
    Divider,
    Grid
} from '@mui/material';
import React, { useEffect, useState } from 'react';

import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import DatePickerUi from "../../../components/form/DatePickerUi";

import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from "react-redux";

import Table from "../../../components/form/Table";
import Question from '../../../components/form/Question';

import { getOrdersToInvoice } from "../../../store/transactions/thunk/invoiceProvider/getOrdersToInvoiceAll";

import { postUploadInvoiceDetails } from "../../../store/transactions/thunk/invoice/postUploadInvoiceDetails";

const Alert = ({
    __,
    open,
    close,
    __o,
    billings
}) => {
    const dispatch = useDispatch();

    const [selected, setSelected] = useState([]);
    const [total, setTotal] = useState([]);
    const [openQuestion, setOpenQuestion] = useState(false);

    const current = useSelector(state => state.transactions.invoiceProvider.detail);
    const order = useSelector(state => state.transactions.invoiceProvider.ordersToInvoice);
    const post = useSelector(state => state.transactions.invoice.invoiceDetails);

    const orderAll = get(order, "data", [])
    const [filter, setFilter] = useState({
          idProvider: get(current, "data.idProvider"),
          startDate: "",
          endDate: ""
      }); 

    useEffect(() => {
        if(filter.idProvider || filter.startDate || filter.endDate) {
            dispatch(getOrdersToInvoice(filter))
        } 
    }, [filter]);

    const handleSelectAllClick = (event) => {
        if (selected.length === orderAll.length) {
            setSelected([]); // Deseleccionar todos
        } else {
            const allSelected = map(orderAll, (item) => item.idRoute);
            setSelected(allSelected); // Seleccionar todos
        }
    };

    
    const handleChecked = (event, id) => {
        let newSelected = [];
        
        if (event.target.checked) {
            newSelected = [...selected, id]; // Añadir al seleccionado
        } else {
            newSelected = selected.filter(item => item !== id); // Quitar del seleccionado
        }
        
        setSelected(newSelected);
    };
    
    const isSelected = (id) => {
        return selected.indexOf(id) !== -1
    }

    const handleDateChange = (field, value) => {
        setFilter((prevFilter) => ({
            ...prevFilter,
            [field]: value
        }));
    };

    const headTable = [
        {
            key: "checkbox",
            label: (
                <Checkbox
                    color="primary"
                    indeterminate={selected.length > 0 && selected.length < orderAll.length}
                    checked={orderAll.length > 0 && selected.length === orderAll.length}
                    onChange={handleSelectAllClick}
                    inputProps={{
                        'aria-label': 'select all desserts',
                    }}
                    disabled={get(post, "isLoading")}
                />
            ),
            align: "center",
            width: 70,
        },
        {
            key: "idRoute",
            label: __(`table.colsInvoices.idRoute`),
            align: "center"
        },
        {
            key: "routeEstatus",
            label: __(`table.colsInvoices.routeEstatus`),
            align: "center"
        },
        {
            key: "routeName",
            label: __(`table.colsInvoices.routeName`),
            align: "center"
        },
        {
            key: "routeDate",
            label: __(`table.colsInvoices.routeDate`),
            align: "center",
            sx: { minWidth: 150 }
        },
        {
            key: "routePuntoCarga",
            label: __(`table.colsInvoices.routePuntoCarga`),
            align: "center"
        },
        {
            key: "routePuntoEntrega",
            label: __(`table.colsInvoices.routePuntoEntrega`),
            align: "center"
        },
        {
            key: "routeCost",
            label: __(`table.colsInvoices.routeCost`),
            align: "center",
            sx: { minWidth: 100 }
        },
    ]

    const dataTable = map(orderAll, (row, i) => {
        const isItemSelected = isSelected(get(row, "idRoute"));
        const labelId = `enhanced-table-checkbox-${i}`;

        return ({
            ...row,
            checkbox: (
                <Checkbox
                    color="primary"
                    checked={isItemSelected}
                    onChange={(e, v) => handleChecked(e, get(row, "idRoute"))}
                    inputProps={{ 'aria-labelledby': labelId, }}
                    disabled={get(post, "isLoading")}
                />
            ),
            routeDate: get(row, "routeDate", "").split('T')[0],
            routeCost: `$ ${get(row, "routeCost", 0)?.toFixed(2)}`,
        })
    })

    const HandleAddInvoices = () => {
         billings(selected);
         setSelected([]);
         setOpenQuestion(false);
         handleClose ();
     }

     const HandleCancelSelected = () => {
        setSelected([]);
        handleClose();  
     }

     const handleClose = () => {
        setFilter({
            idProvider: get(current, "data.idProvider"),
            startDate: "",
            endDate: "",
        });
        close();
    };


    return (
        <div>
            <Dialog onClose={handleClose} open={open} maxWidth="lg" fullWidth>
                <Box>
                    <Typography variant="h6" sx={{ mt: 2, mb: 1, ml: 3 }}>
                        {__("labels.3")}
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={HandleCancelSelected}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Divider />
                <Box className='p-4' >
                    <Grid container spacing={{ xs: 2, md: 3 }}>
                        <Grid item xs={12} sm={6} md={6}>
                            <DatePickerUi
                                name="startDate"
                                label={__(`form.startDate.label`)}
                                labelInput
                                placeholder={__(`form.StartDate.placeholder`)}
                                value={filter.startDate || null}
                                onChange={(value) => handleDateChange("startDate", value)}
                                />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <DatePickerUi
                                name="endDate"
                                label={__(`form.endDate.label`)}
                                labelInput
                                placeholder={__(`form.endDate.placeholder`)}
                                value={filter.endDate || null}
                                onChange={(value) => handleDateChange("endDate", value)}
                                />
                        </Grid>
                    </Grid>
                </Box>
                <Divider />
                <Table
                    headTable={headTable}
                    dataTable={dataTable}
                    __={__}
                    sizeFilters={125}
                    loading={get(order, "isLoading", false)}
                    empty="invoices"
                    propsTable={{
                        size: "small"
                    }}
                />
                <Stack className='p-4' direction="row" spacing={2} justifyContent="flex-end">
                    <LoadingButton className='w-[100px] min-w-[100px]' variant="contained" color="secondary" onClick={() => setOpenQuestion(true)} disabled={get(post, "isLoading") || isEmpty(selected)} loading={get(post, "isLoading")}>{__("action.save")}</LoadingButton>
                    <Button className='w-[100px] min-w-[100px]' variant='outlined' color="secondary" onClick={HandleCancelSelected} >{__(`action.cancel`)}</Button>
                </Stack>
            </Dialog>
            <Question
                title={__("alert.import.title")}
                detail={__("alert.import.detail")}
                onSuccess={HandleAddInvoices}
                onCancel={() => setOpenQuestion(false)}
                open={openQuestion}
            />
        </div >
    );
}

export default Alert